<template>

    <form ref="parametro-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            
					<div class="form-group col-md-12">
                        <label for="chave">Chave</label>
                        <input type="text" class="form-control" name="chave" placeholder="Chave" v-model="model.chave" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="descricao">Descri��o</label>
                        <input type="text" class="form-control" name="descricao" placeholder="Descricao" v-model="model.descricao"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="label">Label</label>
                        <input type="text" class="form-control" name="label" placeholder="Label" v-model="model.label"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="moduloId">ModuloId</label>
                        <input type="text" class="form-control" name="moduloId" placeholder="ModuloId" v-model="model.moduloId" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="tipoCampo">TipoCampo</label>
                        <input type="text" class="form-control" name="tipoCampo" placeholder="TipoCampo" v-model="model.tipoCampo" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="valorPadrao">ValorPadrao</label>
                        <input type="text" class="form-control" name="valorPadrao" placeholder="ValorPadrao" v-model="model.valorPadrao" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="ressalva">Ressalva</label>
                        <input type="text" class="form-control" name="ressalva" placeholder="Ressalva" v-model="model.ressalva"  />
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="sistema" class="custom-control-input" v-model="model.sistema">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Sistema?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <label for="ordem">Ordem</label>
                        <input type="text" class="form-control" name="ordem" placeholder="Ordem" v-model="model.ordem"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="parametroHabilitarId">ParametroHabilitarId</label>
                        <input type="text" class="form-control" name="parametroHabilitarId" placeholder="ParametroHabilitarId" v-model="model.parametroHabilitarId"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="parametroDesabilitarId">ParametroDesabilitarId</label>
                        <input type="text" class="form-control" name="parametroDesabilitarId" placeholder="ParametroDesabilitarId" v-model="model.parametroDesabilitarId"  />
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "parametro-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "parametro-form-create",
            
            resources: {
                create: 'parametro',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

